import React from "react";
import { Tooltip } from "antd";
import type { TCommunicationTask } from "../helpers/communication-types-helper";

interface ICommunicationInfoFieldProps {
  task: TCommunicationTask;
}

const CommunicationInfoField: React.FC<ICommunicationInfoFieldProps> = ({ task }) => (
  <div className="communication-info-field">
    <Tooltip title={task.subject}>
      <strong className="communication-info-field__subject">{task.subject || "\u2014"}</strong>
    </Tooltip>
    {task.sender_email ? (
      <Tooltip title={task.sender}>
        <a className="communication-info-field__sender" href={`mailto:${task.sender_email}`}>
          {task.sender}
        </a>
      </Tooltip>
    ) : (
      <Tooltip title={task.sender}>
        <span className="communication-info-field__sender">{task.sender}</span>
      </Tooltip>
    )}
  </div>
);

export default CommunicationInfoField;
